<template>
    <v-dialog :model-value="modelValue" @update:model-value="$emit('update:modelValue', $event)" max-width="560">
        <v-card v-if="manutenzione">
            <v-card-title class="d-flex align-center">
                <v-icon :color="daAvviare ? 'orange-darken-2' : 'blue'" class="mr-2">
                    {{ daAvviare ? 'mdi-progress-wrench' : 'mdi-check-circle' }}
                </v-icon>
                <div>
                    <div>{{ daAvviare ? 'Manutenzione pianificata' : 'Manutenzione completata' }}</div>
                    <div class="text-caption text-medium-emphasis font-weight-regular">
                        {{ manutenzione.macchinaNome }} — {{ manutenzione.tipoManutenzioneNome }}
                    </div>
                </div>
                <v-spacer />
                <v-btn icon variant="text" size="small" @click="chiudi">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-card-title>

            <v-card-text>
                <!-- Non ancora avviata: nessun dato di completamento da mostrare, solo
                     un riepilogo per far confermare consapevolmente il fermo macchina
                     prima di avviarla (prima si avviava subito al click, senza chiedere). -->
                <template v-if="daAvviare">
                    <v-alert type="warning" variant="tonal" density="comfortable" class="mb-3">
                        Questa manutenzione richiede il fermo macchina. Avviandola, la macchina risulterà
                        "In manutenzione" fino al completamento.
                    </v-alert>
                    <v-row dense class="mb-1">
                        <v-col cols="6">
                            <div class="text-caption text-medium-emphasis">Data prevista</div>
                            <div class="font-weight-medium">{{ formattaData(manutenzione.dataPrevista) }}</div>
                        </v-col>
                        <v-col cols="6">
                            <div class="text-caption text-medium-emphasis">Stato</div>
                            <div class="font-weight-medium">{{ manutenzione.stato }}</div>
                        </v-col>
                    </v-row>
                    <template v-if="manutenzione.descrizione">
                        <div class="text-caption text-medium-emphasis mt-3">Descrizione</div>
                        <div class="text-body-2">{{ manutenzione.descrizione }}</div>
                    </template>
                </template>

                <template v-else>
                    <v-row dense class="mb-1">
                        <v-col cols="6">
                            <div class="text-caption text-medium-emphasis">Data completamento</div>
                            <div class="font-weight-medium">{{ formattaData(manutenzione.dataCompletamento) }}</div>
                        </v-col>
                        <v-col cols="6">
                            <div class="text-caption text-medium-emphasis">Eseguita da</div>
                            <div class="font-weight-medium">{{ manutenzione.eseguitaDaNome || "—" }}</div>
                        </v-col>
                    </v-row>

                    <template v-if="manutenzione.descrizione">
                        <div class="text-caption text-medium-emphasis mt-3">Descrizione pianificata</div>
                        <div class="text-body-2">{{ manutenzione.descrizione }}</div>
                    </template>

                    <template v-if="manutenzione.noteCompletamento">
                        <div class="text-caption text-medium-emphasis mt-3">Note di completamento</div>
                        <div class="text-body-2">{{ manutenzione.noteCompletamento }}</div>
                    </template>

                    <template v-if="manutenzione.ricambiUsati && manutenzione.ricambiUsati.length">
                        <div class="text-caption text-medium-emphasis mt-3 mb-1">Ricambi utilizzati</div>
                        <v-chip v-for="r in manutenzione.ricambiUsati" :key="r.ricambioId" size="small" variant="tonal"
                            class="mr-1 mb-1">
                            {{ r.ricambioNome }} × {{ r.quantita }}
                        </v-chip>
                    </template>

                    <template v-if="manutenzione.foto && manutenzione.foto.length">
                        <div class="text-caption text-medium-emphasis mt-3 mb-1">Foto</div>
                        <v-row dense>
                            <v-col v-for="f in manutenzione.foto" :key="f.id" cols="6" sm="4">
                                <v-card variant="outlined" class="rounded-lg pa-2 d-flex align-center">
                                    <v-icon size="small" class="mr-1">mdi-image</v-icon>
                                    <span class="text-caption text-truncate">{{ f.nomeOriginale }}</span>
                                </v-card>
                            </v-col>
                        </v-row>
                    </template>
                </template>
            </v-card-text>

            <v-card-actions>
                <v-spacer />
                <v-btn variant="text" @click="chiudi">Chiudi</v-btn>
                <v-btn v-if="daAvviare" color="orange-darken-2" variant="flat" :loading="avviando" @click="avvia">
                    Avvia manutenzione
                </v-btn>
                <v-btn v-else color="primary" variant="text" @click="vaiMacchina">Vai alla macchina</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    name: "DialogDettaglioManutenzione",

    props: {
        modelValue: { type: Boolean, default: false },
        manutenzioneId: { type: [Number, String], default: null },
    },
    emits: ["update:modelValue", "iniziata"],

    data() {
        return {
            avviando: false,
        };
    },

    computed: {
        manutenzione() {
            return this.$store.getters["manutenzioni/corrente"];
        },

        // Vero solo per manutenzioni con fermo macchina non ancora avviate: prima
        // il click sull'evento le avviava subito, senza conferma dell'utente.
        daAvviare() {
            return !!this.manutenzione
                && this.manutenzione.stato === "Pianificata"
                && this.manutenzione.richiedeFermoMacchina;
        },
    },

    watch: {
        modelValue(val) {
            if (val && this.manutenzioneId) {
                this.$store.dispatch("manutenzioni/caricaDettaglio", this.manutenzioneId);
            }
        },
    },

    methods: {
        formattaData(iso) {
            if (!iso) return "—";
            return new Date(iso).toLocaleDateString("it-IT", {
                day: "numeric", month: "long", year: "numeric",
            });
        },

        chiudi() {
            this.$emit("update:modelValue", false);
        },

        vaiMacchina() {
            if (this.manutenzione) {
                this.$router.push("/macchine/" + this.manutenzione.macchinaId);
            }
            this.chiudi();
        },

        async avvia() {
            if (!this.manutenzione) return;
            this.avviando = true;
            try {
                await this.$store.dispatch("manutenzioni/inizia", {
                    id: this.manutenzione.id,
                    macchinaId: this.manutenzione.macchinaId,
                });
                this.$emit("iniziata");
                this.chiudi();
            } catch (error) {
                console.log(error);
            }
            this.avviando = false;
        },
    },
};
</script>
